<script>
import EntryCollapse from '@/pages/layouts/partials/sidebar/entry-collapse.vue'
import MenuItem from '@/pages/layouts/partials/sidebar/menu-item.vue';
import FormElements from '@/mixins/shared/formElements'

export default {
    mixins: [FormElements],
    components: {
        EntryCollapse, MenuItem
    },
    inject: ['form'],
    props: {
        entry: {
            type: Object,
            required: true,
        }
    },
    methods: {
        open() {
            this.$refs.collapse.open();
        },

        close() {
            this.$refs.collapse.close();
        },
    }
}
</script>

<template>
    <div :data-entry-id="entry.id">
        <EntryCollapse ref="collapse" :entry="entry">
            <Input
                :form="form"
                :required="true"
                v-model="entry.label"
                :name="`entries[${entry.id}][label]`"
                label="Label"
            />
            <Icon
                :form="form"
                :required="true"
                v-model="entry.icon" 
                :name="`entries[${entry.id}][icon]`" 
                label="Icoon" 
            />
        </EntryCollapse>
        
        <!-- Sortable dropzone for folder children -->
        <div 
            class="sortable-dropzone d-flex flex-column gap-3 ps-5" 
            :class="{'mt-3': entry.children && entry.children.length > 0 }"
        >
            <component
                v-for="child in entry.children"
                :key="child.id"
                :is="child.is_folder ? 'Folder' : 'MenuItem'"
                :entry="child"
                :data-entry-id="child.id"
            />
        </div>
    </div>
</template>

<style scoped>
.sortable-dropzone {
    border-left: 2px solid #e9ecef;
    position: relative;
}

.sortable-empty-state {
    font-style: italic;
    opacity: 0.6;
}

/* Show dropzone border when dragging over it */
.sortable-dropzone:has(.sortable-ghost) {
    border-left-color: #0d6efd;
    background: #f8f9fa;
}
</style>
